import { Text, Timeline } from "@mantine/core";
import type { ReactNode } from "react";
import type { SemanticRole } from "@how/design-system";
import { semanticRoles } from "@how/design-system";

export interface ActivityItem {
  readonly id: string;
  readonly title: string;
  readonly description?: ReactNode;
  /** Already-formatted, user-facing time text (for example "2 hours ago" or "Sep 15, 2026 10:04"). */
  readonly when: string;
  readonly role?: SemanticRole;
  readonly icon?: ReactNode;
}

export interface ActivityTimelineProps {
  readonly items: readonly ActivityItem[];
  readonly emptyText?: string;
}

/** Chronological activity list (audit events, membership changes, session events). */
export function ActivityTimeline({ items, emptyText = "No activity yet." }: ActivityTimelineProps) {
  if (items.length === 0) {
    return (
      <Text c="dimmed" size="sm">
        {emptyText}
      </Text>
    );
  }
  return (
    <Timeline active={items.length} bulletSize={22} lineWidth={1}>
      {items.map((item) => (
        <Timeline.Item
          key={item.id}
          title={item.title}
          bullet={item.icon}
          color={semanticRoles[item.role ?? "neutral"]}
        >
          {item.description !== undefined && (
            <Text size="sm" c="dimmed">
              {item.description}
            </Text>
          )}
          <Text size="xs" c="dimmed" mt={4}>
            {item.when}
          </Text>
        </Timeline.Item>
      ))}
    </Timeline>
  );
}
